import React from 'react'
import Layout from '../../../components/common/pageLayout'
import Component from '../../../components/Production/pending/NonConformityReport'

const NonConformityReport = () => {
  return (
    <Layout
            title={'NON CONFORMITY REPORT INDEX'}
        >
      <Component />


        </Layout>
  )
}

export default NonConformityReport